import urlBase64ToUint8Array from './urlBase64ToUint8Array';

const subscribeUserToPush = () => navigator.serviceWorker.ready
  .then((reg) => {
    const subscribeOptions = {
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(
        'BCMeMMG0jszEnlyLgeAi_kOslxtiLdPMHvKsGiHjhdiJAHpbJ-WKE8RtIpK_SwWQyB4bG4NzcFocb7n7lGw5ZP8'
      )
    };

    return reg.pushManager.subscribe(subscribeOptions);
  });

export default subscribeUserToPush;
